function LoginActivity() {
    return (
      <>
        <div className="font-bold text-lg mb-16">LoginActivity</div>
      </>
    );
  }
  
  export default LoginActivity;